import { ReactElement, useEffect, useRef, useState } from 'react';

import { Virtual } from 'swiper';

import styled from '@/styled';

import CarouselNavigator from './Navigator';

interface IProps {
  children?: ReactElement[] | ReactElement;
  className?: string;
  slidesToShow: number;
  spaceBetween?: number;
}

interface ICarrouselStyleProps {
  index?: number;
}

const CarouselComponent = (props: IProps & ICarrouselStyleProps) => {
  const swiperRef = useRef(null);
  const [reach, setReach] = useState({
    beginning: true,
    end: false
  });
  useEffect(() => {
    if (!swiperRef.current) {
      return;
    }

    swiperRef.current.swiper.onAny((_: any, swiper: any) => {
      setReach({
        beginning: swiper.isBeginning,
        end: swiper.isEnd
      });
    });

    Object.assign(swiperRef.current, {
      virtual: true,
      breakpoints: {
        320: {
          slidesPerView: 1.3,
          slidesPerGroup: 1,
          spaceBetween: 16
        },
        640: {
          slidesPerView: props.slidesToShow,
          spaceBetween: props.spaceBetween || 24
        }
      },
      modules: [Virtual],
      injectStylesUrls: ['swiper/element/css/virtual']
    });
    swiperRef.current.initialize();
  }, [props.slidesToShow]);
  return (
    <div className={props.className}>
      {!reach.beginning && <CarouselNavigator swiperRef={swiperRef} side='left' />}
      <swiper-container
        ref={swiperRef}
        slides-per-group={props.slidesToShow}
        slides-per-view={props.slidesToShow}
        navigation='true'
      >
        {props.children}
      </swiper-container>
      {!reach.end && <CarouselNavigator swiperRef={swiperRef} side='right' />}
    </div>
  );
};

export default styled(CarouselComponent)`
  position: relative;
  width: 100%;
  z-index: ${(props: ICarrouselStyleProps) => props.index || 1};
`;
